<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商家编码" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.code" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="商户状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="审核中" :value="0">审核中</el-option>
							<el-option key="1" label="正常" :value="1">正常</el-option>
							<el-option key="2" label="驳回" :value="2">驳回</el-option>
							<el-option key="3" label="停用" :value="3">停用</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="ID" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入商户ID"></el-input>
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="所属区域:" label-width="80px">
							<el-select clearable filterable v-model="searchInfo.province" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="searchInfo.city" placeholder="请选择市"
								@change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="searchInfo.area" placeholder="请选择区"
								@change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<el-button type="primary" @click="dialogVisibleFun()">新增商户</el-button>
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
					</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商户名称">
							<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
							<span v-else>无</span>
						</el-form-item>

						<el-form-item label="商家编码">
							<span>{{ props.row.code }}</span>
						</el-form-item>
						<el-form-item label="维护协议价">
							<span v-if="props.row.isEditSaleprice">是</span>
							<span v-else>否</span>
						</el-form-item>
						<el-form-item label="预存款">
							<span>￥{{ props.row.deposit}}</span>
						</el-form-item>
						<el-form-item label="授信额度">
							<span>￥{{ props.row.quotaAvailableBalance}}(￥{{props.row.quota}})</span>
						</el-form-item>
						<el-form-item label="详细地址">
							<span>{{ props.row.address}}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeLogo" label="商户logo" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="storeName" label="商户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="code" label="商家编码" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="商户状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.checkStatus>0" @click="checkStore(scope.row)">待审核</p>
					<p v-else>
						<span v-if="scope.row.status==0">待审核</span>
						<span v-if="scope.row.status==1">正常</span>
						<span v-if="scope.row.status==2">审核驳回</span>
						<span v-if="scope.row.status==3">停用</span>
					</p>
				</template>
			</el-table-column>
			<el-table-column prop="cidImages" label="商户证件" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button @click="lookcImages(scope.row.cidImages)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="scope.row.checkStatus!=0&&storeType==3" 
							@click.native="checkStore(scope.row)">审核
							</el-dropdown-item>
							<!-- <el-dropdown-item v-if="scope.row.status==0&&storeType==3" @click.native="delcheckStore(scope.row.id)">驳回
							</el-dropdown-item> -->
							<el-dropdown-item @click.native="storeuserset(scope.row.id)">联系人管理</el-dropdown-item>
							<el-dropdown-item @click.native="shlook(scope.row.id)">审核记录
							</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)">预存款/授信记录
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.status==3" >已停用</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.status==0&&storeType==3" @click.native="toTy(scope.row.id)">停用</el-dropdown-item>
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>　　
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
			<div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="80%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="padding: 10px;margin-bottom: 20px;" v-if="dialogVisibleFunName=='新增商户'">
						<div style="text-align: start;height: 80px;line-height: 80px;font-size: 18px;">超级管理员</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="登录名" class="redItem">
								<el-input type="text" size="small" width="50" v-model="storeGoodsInfo.username"
									placeholder="请输入登录名" />
							</el-form-item>
							<el-form-item label="登录密码" class="redItem">
								<el-input type="password" size="small" width="50" v-model="storeGoodsInfo.password"
									placeholder="请输入登录密码" />
							</el-form-item>
							<el-form-item label="手机号" class="redItem">
								<el-input type="number" size="small" width="50" v-model="storeGoodsInfo.phone"
									placeholder="请输入手机号" />
							</el-form-item>
						</div>
					</div>
					<div style="text-align: start;height: 80px;line-height: 80px;font-size: 18px;width: 100%;">商户信息
					</div>
					<div style="display: flex;align-items: center;justify-content: start;">
						<el-form-item label="商户名称:" style="width: 35%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.storeName" placeholder="请输入商品名称" />
						</el-form-item>
						<el-form-item label="商家编码:" style="width: 30%;margin-left: 10px;">
							<el-input v-model="storeGoodsInfo.code" placeholder="请输入商家编码">
							</el-input>
						</el-form-item>
					
					</div>
					<div>
						<el-form-item label="预存款:" style="width: 20%;" v-if="dialogVisibleFunName!='新增商户'">
							<span>￥{{storeGoodsInfo.deposit}}</span>
						</el-form-item>
						<el-form-item label="授信额度:" style="width: 30%;" v-if="dialogVisibleFunName=='新增商户'">
							<el-input type="number" v-model="storeGoodsInfo.quota" placeholder="请输入授信额度">
							</el-input>
						</el-form-item>
						<el-form-item label="授信额度:" style="width: 30%;" v-else>
							<span>￥{{storeGoodsInfo.quotaAvailableBalance}}(￥{{storeGoodsInfo.quota}})</span>
						</el-form-item>
					
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="所属区域:" label-width="75px">
							<el-select clearable filterable v-model="storeGoodsInfo.province" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.city" placeholder="请选择市"
								@change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.area" placeholder="请选择区"
								@change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item label="详细地址:" label-width="75px" style="width: 50%;">
						<el-input v-model="storeGoodsInfo.address" placeholder="请输入详细地址">
						</el-input>
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商户邮箱:" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.email" placeholder="请输入商户邮箱" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商户LOGO:" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit=1
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商户证件:" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card"
								:on-preview="handlePictureCardPreview1" :on-remove="handleRemove1"
								:file-list="fileList1" :show-file-list="true" :on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="height: 600px;">
						<div style="text-align: start;margin: 10px;">商户介绍</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.storeIntro" ref="myQuillEditor" class="editer"
									style="height: 400px;width: 1000px;" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增商户'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑商户'" type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialoguser" title="联系人管理" @close="addDialogClose" :close-on-click-modal="false"  width='1000px'>
			<div>
				<el-table :data="storelinks1">
					<el-table-column property="linkUser" label="联系人"></el-table-column>
					<el-table-column property="phone" label="电话"></el-table-column>
					<el-table-column property="identity" label="身份"></el-table-column>
					<el-table-column property="wx" label="微信"></el-table-column>
					<el-table-column property="qq" label="qq"></el-table-column>
					<el-table-column property="email" label="邮箱"></el-table-column>
					<el-table-column property="address" label="地址">
						<template slot-scope="scope">
					{{scope.row.province}} 	{{scope.row.city}} 	{{scope.row.area}} {{scope.row.address}} 
						</template>
						
					</el-table-column>
					<el-table-column label="操作" property="id">
							<template slot-scope="scope">
								<span style="color: skyblue;" @click="setuser(scope.row.id)" >编辑</span>
							<span style="color: red;" @click="storeuserdel(scope.row.id)"> 删除</span>
							<!-- 	<el-dropdown trigger="click" style="margin-left: 10px;">
									<el-button type="text" size="small">更多</el-button>
									<el-icon class="el-icon-caret-bottom"></el-icon>
									<el-dropdown-menu slot="dropdown">
										
										<el-dropdown-item @click.native="storeuserdel(scope.row.id)">删除</el-dropdown-item>
											<el-dropdown-item @click.native="setuser(scope.row.id)">编辑
													</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>　 -->　
							</template>　
					</el-table-column>
				</el-table>
				<el-button type="primary" @click="setuser('')">新增联系人</el-button>
			</div>
			<el-dialog width="60%" :title=usertitle :visible.sync="innerVisible" append-to-body :close-on-click-modal="false">
				<el-form v-model="storelinks">
					<el-form-item label="联系人:" label-width="75px">
						
						<el-input type="text" style="width: 300px;" v-model="storelinks.linkUser" auto-complete="off"
							placeholder="请输入联系人姓名(必填)" />
					</el-form-item>
					<el-form-item label="手机号:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="storelinks.phone" auto-complete="off"
							placeholder="请输入手机号(必填)" />
					</el-form-item>
					<el-form-item label="身份介绍:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="storelinks.identity" auto-complete="off"
							placeholder="请输入联系人身份(例如:'经理')" />
					</el-form-item>
					<el-form-item label="微 信:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="storelinks.wx" auto-complete="off"
							placeholder="请输入联系人微信" />
					</el-form-item>
					<el-form-item label="q  q:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="storelinks.qq" auto-complete="off"
							placeholder="请输入联系人qq" />
					</el-form-item>
					<el-form-item label="邮箱:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="storelinks.email" auto-complete="off"
							placeholder="请输入联系人邮箱" />
					</el-form-item>
					<el-form-item label="所属区域:" label-width="75px" style="width: 50%;">
						<el-select clearable filterable v-model="storelinks.province" placeholder="请选择省"
							@change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="storelinks.city" placeholder="请选择市" @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="storelinks.area" placeholder="请选择区"
							@change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="详细地址:" label-width="75px" style="width: 50%;">
						<el-input v-model="storelinks.address" placeholder="请输入详细地址">
						</el-input>
					</el-form-item>
					<el-button type="primary" @click="submitClick(storelinks.id)">提交</el-button>
				</el-form>
			</el-dialog>
		</el-dialog>
		<el-dialog :visible.sync="dialogcimg" title="商户证件" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;">
				<el-carousel-item v-for="(item,index) in cImages" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<el-button type="primary" @click="dialogcimg = false">关 闭</el-button>
		</el-dialog>
		<el-dialog title="商户驳回" :visible.sync="dialogbhVisible">
			<el-form :model="formbh">
				<el-form-item label="驳回原因:">
					<el-input v-model="formbh.detail" autocomplete="off" placeholder="请输入驳回原因"></el-input>
				</el-form-item>
		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogbhVisible = false">取 消</el-button>
				<el-button type="primary" @click="suredetail">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="审核记录" :visible.sync="dialogshVisible" style="width: 1800px;">
			<el-table
			      :data="tableData"
			      style="width: 100%">
			      <el-table-column
			        prop="id"
			        label="ID"
			        width="100">
			      </el-table-column>
			      
			      <el-table-column
			        prop="fromDetail"
			        label="修改前状态">
					<template slot-scope="scope">
						<el-span v-if="scope.row.fromDetail==0">待审核</el-span>
					  <el-span v-if="scope.row.fromDetail==1">已审核</el-span>
					  <el-span v-if="scope.row.fromDetail==2">驳回</el-span>
					  <el-span v-if="scope.row.fromDetail==3">停用</el-span>
					</template>
			      </el-table-column>
				
				  <el-table-column
				    prop="toDetail"
				    label="修改后状态">
					<template slot-scope="scope">
						<el-span v-if="scope.row.toDetail==0">待审核</el-span>
					  <el-span v-if="scope.row.toDetail==1">已审核</el-span>
					  <el-span v-if="scope.row.toDetail==2">驳回</el-span>
					  <el-span v-if="scope.row.toDetail==3">停用</el-span>
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="remark"
				    label="说明">
				  </el-table-column>
				  <el-table-column
				    prop="vertifyBy"
				    label="审核人"
				    width="180">
				  </el-table-column>
				  <el-table-column
				    prop="createTime"
				    label="修改时间"
				    width="180">
				  </el-table-column>
			    </el-table>
		</el-dialog>
		<el-dialog :visible.sync="dialogshenheVisible" title="审核">
			<div style="display: flex;">
				<el-form :model="fromDetail" style="margin-left: 10px;">
					<el-span style="font-weight: 800;">原信息</el-span>
					<el-form-item>商户名称：{{fromDetail.storeName}}</el-form-item>
					<el-form-item>地址：{{fromDetail.province}}{{fromDetail.city}}{{fromDetail.area}}{{fromDetail.address}}</el-form-item>
					<el-form-item>商户邮箱：{{fromDetail.email}}</el-form-item>
					<el-form-item>商户LOGO：
					<img :src="fromDetail.storeLogo" alt="">
					</el-form-item>
					<el-form-item>商户证件：
						<el-button @click="lookcImages(fromDetail.cidImages)">查看</el-button>
					</el-form-item>
					<el-form-item>商户介绍：
					<el-button @click="lookxq(fromDetail.storeIntro)">查看</el-button>
					</el-form-item>
					
				</el-form>
				<el-form :model="toDetail" style="margin-left: 20px;">
					<el-span style="font-weight: 800;">修改后信息</el-span>
					<el-form-item>商户名称：{{toDetail.storeName}}</el-form-item>
					<el-form-item>地址：{{toDetail.province}}{{fromDetail.city}}{{toDetail.area}}{{toDetail.address}}</el-form-item>
					<el-form-item>商户邮箱：{{toDetail.email}}</el-form-item>
					<el-form-item>商户LOGO：
					<img :src="toDetail.storeLogo" alt="">
					</el-form-item>
					<el-form-item>商户证件：
						<el-button @click="lookcImages(toDetail.cidImages)">查看</el-button>
					</el-form-item>
					<el-form-item>商户介绍：
					<el-button @click="lookxq(toDetail.storeIntro)">查看</el-button>
					</el-form-item>
					
				</el-form>
			</div>
			<div>
				<el-span style="padding-left: 10px;">备注：</el-span>{{czobj.remark}}
			</div>
			<div slot="footer" class="dialog-footer" style="">
				<el-button @click="delcheckStore(czobj.id)">驳 回</el-button>
				<el-button type="primary" @click="shtg(czobj.id)">通 过</el-button>
			</div>
			
		</el-dialog>
		<el-dialog  :visible.sync="dialogIntroVisible" title="详情">
			<div v-html="storeIntro"></div>
		</el-dialog>
		<el-dialog title="预存款/授信记录" :visible.sync="dialogshVisibleck" style="width: 1800px;">
			<el-table
			      :data="tableData1"
			      style="width: 100%">
			      <el-table-column
			        prop="id"
			        label="ID"
			        width="100">
			      </el-table-column>
			      <el-table-column
			        prop="code"
			        label="编码"
			        width="100">
			      </el-table-column>
			      <el-table-column
			        prop="storeName"
			        label="商户名称">
					
			      </el-table-column>
				
				  <el-table-column
				    prop="changeType"
				    label="收支">
					<template slot-scope="scope">
						<el-span v-if="scope.row.changeType==-1">支出</el-span>
					  <el-span v-if="scope.row.changeType==1">收入</el-span>
					 
					</template>
				  </el-table-column>
				  <el-table-column
				    prop="amount"
				    label="金额">
				  					
				  </el-table-column>
				  <el-table-column
				    prop="memo"
				    label="备注">
				  </el-table-column>
				  <el-table-column
				    prop="operBy"
				    label="审核人"
				    width="180">
				  </el-table-column>
				  <el-table-column
				    prop="createTime"
				    label="修改时间"
				    width="180">
				  </el-table-column>
			    </el-table>
		</el-dialog>
	</div>
</template>
<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				dialogshVisibleck:false,
				storeIntro:'',
				dialogIntroVisible:false,
				czobj:{},
				dialogshenheVisible:false,
				fromDetail:{},
				toDetail:{},
				usertitle:'',
				formbh:{},
				tableData:[],
				tableData1:[],
				innerVisible: false,
				dialogshVisible:false,
				dialogbhVisible:false,
				cImages: [],
				dialogcimg: false,
				dialoguser: false,
				setUpBuyVisible: false,
				goodsImages: '',
				goodsImages1: [],
				orderInfo: {},
				fileList: [],
				fileList1: [],
				storelinks:{},
				storelinks1:[],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,

				storeGoodsInfo: {
					classId: "",
					isDh: false,
				},
				provinceList: {},
				storeType:'',
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				userList: [],
				ids:'',
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				}
			};
		},

		methods: {
			storeGoodsHitTheShelfOrSoldOut(id){
				this.dialogshVisibleck=true
				this.$api.depositlist(this.$encrypt({storeId:id})).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res);
					this.tableData1=res.data.list	
				})
			},
			lookxq(storeIntro){
				this.dialogIntroVisible=true
				this.storeIntro=storeIntro
			},
			//通过审核
			shtg(id){
				this.$confirm('此操作将审核通过该商户修改的资料, 是否继续?', '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				   this.$api.checkStore(this.$encrypt({id:id,status:1})).then(res=>{
				   	if (res.state == 'success') {
				   		this.$message({
				   			message: res.message,
				   			type: 'success'
				   		});
				   		this.dialogshenheVisible=false
				   		this.getuserList();
				   	} else {
				   		this.$message.error(res.message);
				   	}
				   					
				   })
				}).catch(() => {
				    this.$message({
				        type: 'info',
				        message: '已取消删除'
				    });
				});
							
			},
			shlook(id){
				this.dialogshVisible=true
				this.$api.checkStore1(this.$encrypt({storeId:id})).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
				
					this.tableData=res.data
				})
			},
			toTy(id){
				var str = "此操作将停用该商户?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.checkStore(this.$encrypt({id:id,status:3})).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
						this.getuserList()
						} else {
							this.$message.error(res.message);
						
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			delcheckStore(id){
				this.formbh={}
				this.idbh=id
				this.dialogbhVisible=true
			},
			suredetail(){
				this.$api.checkStore(this.$encrypt({id:this.idbh,status:2, remark:this.formbh.detail})).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
								this.dialogbhVisible=false	
								this.dialogshenheVisible=false
						this.getuserList();
					} else {
						this.$message.error(res.message);
					}
									
				})
			},
			checkStore(item){
				// console.log(item);
				this.dialogshenheVisible=true
				this.$api.findshById(item.checkStatus).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					
					this.fromDetail=JSON.parse(res.data.fromDetail)
					this.toDetail=JSON.parse(res.data.toDetail)
					this.czobj=res.data
				})
				
				
			},
			storeuserdel(id){
				var str = "此操作将删除该联系人, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delStoreLinks(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.storeuserset(this.ids);
						} else {
							this.$message.error(res.message);
							this.storeuserset(this.ids);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			setuser(id){
				// console.log(id);
				this.innerVisible=true
				if(id!=''){
						this.usertitle='编辑联系人'
						this.$api.findStoreLinksById(id).then(res=>{
							res.data=JSON.parse(this.$decrypt(res.data)).data
					   
							this.storelinks=res.data[0];
						})
				}else{
					this.usertitle='新增联系人'
							this.storelinks={}
				}
			
			},
			submitClick(id) {
				// console.log(id,this.orderInfo,this.storelinks);
				
				if(id){
					let data={
							address:this.storelinks.address,
							linkUser:this.storelinks.linkUser,
							identity:this.storelinks.identity,
							email:this.storelinks.email,
							wx:this.storelinks.wx,
							qq:this.storelinks.qq,
							phone:this.storelinks.phone,
							...this.orderInfo,
							id:id
					}
					
					this.$api.editStoreLinks(this.$encrypt(data)).then(res=>{
						// console.log(res);
						if(res.state='success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
						
						}else{
							this.$$message.error(res.message)
						}
						this.storeuserset(this.ids)
							this.innerVisible=false
					})
				}else{
					let data={
						address:this.storelinks.address,
						linkUser:this.storelinks.linkUser,
						identity:this.storelinks.identity,
						email:this.storelinks.email,
						phone:this.storelinks.phone,
						wx:this.storelinks.wx,
						qq:this.storelinks.qq,
						...this.orderInfo,
						storeId:this.ids
					}
					this.$api.addStoreLinks(this.$encrypt(data)).then(res=>{
						// console.log(res);
						if(res.state='success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
						
						}else{
							this.$$message.error(res.message)
						}
						this.storeuserset(this.ids)
							this.innerVisible=false
					})
				}
				
			},
			lookcImages(a) {

				// console.log(a.split(','));
				this.cImages = a.split(',')
				this.dialogcimg = true
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			//导出
			addDialogClose() {
				this.storelinks={}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			onSuccess1(response, file, fileList) {
				// console.log(res)
				this.goodsImages1.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.goodsImages1.remove(file.response.message);
				}
				this.goodsImages1.remove(file.url);
			},
			handlePictureCardPreview1(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages = response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages = ''
				}
				this.goodsImages = ''
			},
			handlePictureCardPreview(file) {

				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			searchStore() {
				let data = {}
				this.$api.supplier(data).then((res) => {
					if (res.state == 'success') {
						//此行代码会出现供应商错误
						// this.storeGoodsInfo.storeId = res.data.list[0].id
						this.accountList = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeuserset(id) {
				this.dialoguser = true
				this.ids=id
				
				this.$api.findStoreLinksByStoreId(id).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					
					if (res.state == 'success') {
						this.storelinks1=res.data
					} else {
						// console.log(456);
					
						// this.$message.error(res.message);
					}
					// console.log(456);
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				// console.log(this.searchInfo);
				this.getuserList()
			},
			//店铺审核
			editStoreInfoCheck(id, authStatus) {
				if (authStatus == 2) {
					//通过驳回
					var data = {
						id: this.storeGoodsId,
						authStatus: authStatus,
						rejected: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						authStatus: authStatus
					}
				}
				this.$api.storeGoodsReview(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getuserList()
					} else {
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.storeGoodsId = id
				this.editDialogVisible = true;
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}

				this.dialogVisibleFunName = "新增商户"
				this.dialogVisible = true;
				this.storeGoodsInfo = {};
				this.orderInfo={}
				this.goodsImages = '';
				this.fileList = [];
				this.fileList1=[]
				if (id) {
					this.dialogVisibleFunName = "编辑商户"
					// this.searchInfo.id=id
					this.$api.getStoreList(this.$encrypt({id:id})).then((res) => {
						res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data.list[0]
							// console.log(this.storeGoodsInfo);
							this.fileList.push({
								url: res.data.list[0].storeLogo
							})
							this.goodsImages=res.data.list[0].storeLogo
								this.goodsImages1=res.data.list[0].cidImages.split(',')
								// console.log(this.goodsImages1);
							let imagesArray = res.data.list[0].cidImages.split(',')
												// console.log(res.data.storeId);
							// this.storeId=
							// this.getStoreAndUser(res.data[0].storeId)
							for (let i = 0; i < imagesArray.length; i++) {
								this.fileList1.push({
									name: imagesArray[i],
									url: imagesArray[i]
								})
							}
								// console.log(this.fileList1);
							// for (let i = 0; i < imagesArray.length; i++) {
							// 	this.fileList.push({
							// 		name: imagesArray[i],
							// 		url: imagesArray[i]
							// 	})
							// }

						}
					})
				}
			},
			//添加商品
			add() {
				// console.log(456, this.goodsImages1.length);
				if (!this.storeGoodsInfo.username) {

					this.$message.error('请输入登录名')
					return
				}
				if (!this.storeGoodsInfo.password) {

					this.$message.error('请输入用户密码')
					return
				}
				if (!this.storeGoodsInfo.phone) {

					this.$message.error('请输入用户手机号')
					return
				}
				if (!this.storeGoodsInfo.code) {

					this.$message.error('请输入商户编码')
					return
				}
				if (!this.storeGoodsInfo.quota) {

					this.$message.error('请输入授信额度')
					return
				}
				if (!this.storeGoodsInfo.storeName) {

					this.$message.error('请输入商户名称')
					return
				}
				if(this.goodsImages.length==0){

					this.$message.error('请上传商户LOGO')
					return
				}
				if(this.goodsImages1.length==0){
					this.$message.error('请上传商户证件')
					return 
				}
				if (!this.storeGoodsInfo.address) {

					this.$message.error('请填写详细地址')
					return
				}
				if (!this.storeGoodsInfo.email) {

					this.$message.error('请填写商户邮箱')
					return
				}
				let data = {
					code: this.storeGoodsInfo.code,
					storeIntro: this.storeGoodsInfo.storeIntro,
					email: this.storeGoodsInfo.email,
					phone: this.storeGoodsInfo.phone,
					storeName: this.storeGoodsInfo.storeName,
					username: this.storeGoodsInfo.username,
					areaId: this.orderInfo.areaId,
					cityId: this.orderInfo.cityId,
					provinceId: this.orderInfo.provinceId,
					password: this.storeGoodsInfo.password,
					storeType: 1,
					city: this.orderInfo.city,
					province: this.orderInfo.province,
					cidImages: this.goodsImages1.join(','),
					area: this.orderInfo.area,
					storeLogo: this.goodsImages,
					address: this.storeGoodsInfo.address,
					quota: this.storeGoodsInfo.quota
				}
				// console.log(this.storeGoodsInfo);
				this.$api.addStore(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.storeGoodsInfo={}
						this.getuserList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//编辑商品
			sure() {
				this.storeGoodsInfo.storeLogo = this.goodsImages.toString();

				this.storeGoodsInfo.cidImages=this.goodsImages1.toString();
				this.storeGoodsInfo.areaId=this.orderInfo.areaId,
				this.storeGoodsInfo.cityId=this.orderInfo.cityId,
				this.storeGoodsInfo.provinceId=this.orderInfo.provinceId,
				this.storeGoodsInfo.city=this.orderInfo.city,
				this.storeGoodsInfo.province=this.orderInfo.province,
				this.storeGoodsInfo.area=this.orderInfo.area,
				this.storeGoodsInfo.address=this.storeGoodsInfo.address
				this.$api.updateStore(this.storeGoodsInfo).then((res) => {
					// console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.storeGoodsInfo={}
						this.getuserList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该商户, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delStore(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getuserList();
						} else {
							this.$message.error(res.message);
							this.getuserList();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getuserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getuserList()
			},


			getStoreAndUser1(e) {
				// console.log('---', e);
				let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				// this.storeGoodsInfo.supplierId = obj.supplierId;
				this.storeGoodsInfo.userId = obj.userId;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},

			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},


			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},

			getuserList() {
				let data = {
					pageNum: 1,
					pageSize: 10,
					storeType: 1,
					...this.searchInfo
				}
				this.$api.getStoreList(this.$encrypt(data)).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res.data.list);
					if (res.state == 'success') {
						this.userList = res.data.list;
					}
				})
				this.$api.findAreas(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			//查询市
			provinceFocus(e) {
				// console.log(e);
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.provinceId = obj.id
				this.orderInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
						// console.log(res.data);
					})
				}
			},
			//查询区
			cityFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.orderInfo.cityId = obj.id
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
				this.orderInfo.areaId = obj.id
			},
		},
		created() {


			this.getuserList()
			this.$api.getUserInfo().then(res=>{
				res.data=JSON.parse(this.$decrypt(res.data)).data
				
				this.storeType=res.data.user.storeType
			})
		}

	};
</script>

<style lang="less" scoped>
	.el-dialog {
		height: 5000px !important;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
